module.exports = __webpack_public_path__ + "img/map-traffic-active.c7cf9f67.png";